export default __webpack_public_path__ + "static/media/ng.5af5b5d7.jpg";